module.exports = __webpack_public_path__ + "static/media/product-bg.d53a3a48.png";